import { registerBlockType } from '@wordpress/blocks';
import { useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';


registerBlockType('custom-pros-carousel/block', {
    title: 'Slider Professionisti',
    icon: 'groups',
    category: 'layout',
    attributes: {
        pros: {
            type: 'array',
            default: []
        }
    },
    edit: ({ attributes, setAttributes }) => {
    
        const { pros } = attributes;

        const fetchPros = () => {
            apiFetch({path: `/wp/v2/professionisti`}).then(res => {
                setAttributes({pros: res});
            })
        }

        useEffect(() => {
            fetchPros();
        }, []);

    
        return (
            <div className='pros-carousel'>
                {pros.map(pro => (
                    <div className='pro-card'>
                        <img className='pro-profile-pic' src={pro.acf.immagine_profilo} />
                        <h4>{pro.title.rendered}</h4>
                        <p>{pro.acf.ruolo_professionista}</p>
                    </div>
                ))}
            </div>
        );
    },
    save: () => {
        return null;
    },
});

